import styled from '@emotion/styled';
import { Variables } from '../../../base/variables';

interface IRowActionsContainerProps {
    $isRead?: boolean;
}

export const RowActionsContainer = styled.div<IRowActionsContainerProps>`
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    padding: 16px 16px 16px 48px;
    gap: 8px;

    position: absolute;
    width: 120px;
    height: ${props => props.$isRead ? '64px' : '100%'};
    right: 0;
    top: ${props => props.$isRead ? 'calc(50% - 64px/2)' : '0'};

    background: ${props => props.$isRead 
        ? `linear-gradient(270deg, ${Variables.Swatches.AlphaMiddleGray10} 66%, ${Variables.Swatches.AlphaMiddleGray0} 100%), linear-gradient(270deg, ${Variables.Swatches.Gray1} 66%, rgba(250, 251, 252, 0) 100%)`
        : `linear-gradient(270deg, ${Variables.Colors.white} 60%, rgba(255, 255, 255, 0.8) 80%, rgba(255, 255, 255, 0) 100%)`
    };
    
    ${props => props.$isRead && `border-bottom: 1px solid ${Variables.Swatches.Gray3};`}

    flex: none;
    order: 1;
    flex-grow: 0;
    z-index: 10;

    opacity: 0;
    transition: opacity 200ms ease-in-out;
    pointer-events: none;

    &.visible {
        opacity: 1;
        pointer-events: auto;
    }
`;

export const ActionButton = styled.button<{ disabled?: boolean }>`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 4px;
    isolation: isolate;

    width: 24px;
    height: 24px;

    background: transparent;
    border: none;
    border-radius: 4px;
    cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
    opacity: ${props => (props.disabled ? 0.5 : 1)};

    flex: none;
    order: 0;
    flex-grow: 0;
    pointer-events: auto;
    position: relative;
    z-index: 1;

    &:hover:not(:disabled) {
        background-color: ${Variables.Colors.n5};
    }

    &:focus {
        outline: 2px solid ${Variables.Colors.p300};
        outline-offset: 1px;
    }

    &:active:not(:disabled) {
        background-color: ${Variables.Colors.n15};
    }

    svg {
        width: 16px;
        height: 16px;
        fill: #4f5f76;
    }
`;

